package com.devi3east.bashbuddy.auth.ui.components.steps

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Checkbox
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.devi3east.bashbuddy.auth.ui.AuthUiState
import com.devi3east.bashbuddy.auth.ui.components.TermsOfServiceText
import com.devi3east.bashbuddy.features.common.util.DateInput
import kotlinx.datetime.Instant

@Composable
fun SignUpLegalStep(
    uiState: AuthUiState,
    dateOfBirth: Instant?,
    onDateOfBirthChange: (Instant?) -> Unit,
    certifiedOfAge: Boolean,
    onCertifiedOfAgeChange: (Boolean) -> Unit,
    agreedToTerms: Boolean,
    onAgreedToTermsChange: (Boolean) -> Unit,
    onNavigateToTerms: () -> Unit,
    isOrganization: Boolean,
    hasAuthority: Boolean,
    onAuthorityChange: (Boolean) -> Unit,
    organizationName: String?,
    hasSubmitted: Boolean
) {
    Text(
        text = "Almost There!",
        style = MaterialTheme.typography.headlineMedium.copy(
            fontWeight = FontWeight.Bold,
            color = MaterialTheme.colorScheme.onSurface
        ),
        textAlign = TextAlign.Center
    )

    Text(
        text = "One last step and you’re in.",
        style = MaterialTheme.typography.bodyMedium.copy(
            color = MaterialTheme.colorScheme.onSurfaceVariant,
            lineHeight = 20.sp
        ),
        textAlign = TextAlign.Center,
        modifier = Modifier.padding(horizontal = 8.dp)
    )

    HorizontalDivider(
        thickness = 1.dp,
        color = MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.3f)
    )

    if (!isOrganization) {
        DateInput(
            dateInstant = dateOfBirth,
            label = "Date of Birth",
            onDateChange = { selected ->
                onDateOfBirthChange(selected)
            }
        )

        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.fillMaxWidth()
        ) {
            Checkbox(
                checked = certifiedOfAge,
                onCheckedChange = onCertifiedOfAgeChange,
                enabled = !hasSubmitted
            )

            Spacer(modifier = Modifier.width(6.dp))

            Text(
                text = "By continuing, I certify that I am at least 18 years of age.",
                style = MaterialTheme.typography.bodyMedium
            )
        }
    } else {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.fillMaxWidth()
        ) {
            Checkbox(
                checked = hasAuthority,
                onCheckedChange = onAuthorityChange,
                enabled = !hasSubmitted
            )

            Spacer(modifier = Modifier.width(6.dp))

            Text(
                text = "I certify that I have the authority to sign up on behalf of $organizationName.",
                style = MaterialTheme.typography.bodyMedium
            )
        }
    }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier.fillMaxWidth()
    ) {
        Checkbox(
            checked = agreedToTerms,
            onCheckedChange = onAgreedToTermsChange,
            enabled = !hasSubmitted
        )

        Spacer(modifier = Modifier.width(6.dp))

        TermsOfServiceText(onNavigateToTerms)
    }

    if (!uiState.errorMessage.isNullOrBlank()) {
        Text(
            text = uiState.errorMessage,
            color = MaterialTheme.colorScheme.error,
            style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Medium),
            textAlign = TextAlign.Center
        )
    }

}